var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html } from 'lit';
import { property, query } from 'lit/decorators.js';
import { PIC, PICBase, customElement, stringDecoder, PICInput, PICWebTable, booleanDecoder, objectDecoder } from '../Internals';
let PICGetAns = class PICGetAns extends PICBase {
    constructor() {
        super(...arguments);
        this.title_ = '';
        this.format = '';
        this.allowResize = false;
        this.disableNav = false;
        this.keepSize = false;
        this.centerOnParent = false;
        this.isHidden_ = false;
    }
    get isHidden() {
        if (this.modal) {
            return this.modal.isHidden;
        }
        this.requestUpdate();
        return this.isHidden_;
    }
    set isHidden(isHidden) {
        this.isHidden_ = isHidden;
        if (this.modal) {
            this.modal.isHidden = isHidden;
        }
    }
    static get styles() {
        const defaultStyle = css ``;
        return css `
            ::slotted([slot="slot-modal-body"]){
                height: auto;
                width: auto;
            }
            ::slotted([slot="slot-modal-footer"]){
                overflow-x: auto;
                overflow-y: hidden;
            }
            ::slotted([slot="slot-getans-footer"]){
                display: flex;
                gap: 14px;
                width: fit-content;
            }
            .getAnsBody {
                padding: 0 !important;
            }
            footer {
                padding: 2px 14px 0px!important;
            }
            
          ${super.styles}
          ${defaultStyle}
        `;
    }
    connectedCallback() {
        super.connectedCallback();
    }
    firstUpdated() {
        this.addHiddenInputs();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.deleteHiddenInputs();
    }
    getHiddenInputs() {
        var _a;
        let hiddenInputs = [];
        const slotBody = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('slot[name="slot-getans-body"]');
        const assignedNodes = slotBody.assignedNodes()[0];
        hiddenInputs = Array.from(assignedNodes.querySelectorAll('input[type="hidden"]'));
        return hiddenInputs;
    }
    addHiddenInputs() {
        let hiddenInputs = this.getHiddenInputs();
        for (let input of hiddenInputs) {
            if (input.id) {
                PIC.getInstance.picInputs.set(input.id, input);
            }
        }
    }
    deleteHiddenInputs() {
        let hiddenInputs = this.getHiddenInputs();
        for (let input of hiddenInputs) {
            if (input.id) {
                PIC.getInstance.picInputs.delete(input.id);
            }
        }
    }
    getPICInputFields(node, PICFieldList, hiddenInputs) {
        if (node) {
            if (node instanceof PICInput || node instanceof PICWebTable) {
                PICFieldList.push(node);
            }
            else if (node instanceof HTMLInputElement && node.type && node.type == 'hidden') {
                hiddenInputs.push(node);
            }
            this.getPICInputFields(node.firstElementChild, PICFieldList, hiddenInputs);
            this.getPICInputFields(node.nextSibling, PICFieldList, hiddenInputs);
        }
        else
            return;
    }
    getFields() {
        var _a;
        let body = ((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('slot[name="slot-getans-body"]')).assignedNodes()[0];
        let PICFieldList = [];
        let hiddenInputs = [];
        let postFields = '';
        this.getPICInputFields(body, PICFieldList, hiddenInputs);
        for (let element of PICFieldList) {
            let submitValue = '';
            if (element instanceof PICWebTable) {
                let selectedRowValues = escape(element.selectedRowValues);
                postFields += `"${element.id + '_selectedvalues'}":"${selectedRowValues}",`;
                submitValue = element.submitValue;
            }
            else if (element instanceof PICBase && element.isinput__) {
                submitValue = element.submitValue;
                submitValue = element.submitValue == null ? '' : escape(element.submitValue);
            }
            if (submitValue == null)
                submitValue = '';
            postFields += `"${element.id}":"${submitValue}",`;
        }
        for (let element of hiddenInputs) {
            postFields += `"${element.id}":"${element.value}",`;
        }
        postFields = postFields.slice(0, -1);
        postFields = `{"postFields":{${postFields}}}`;
        return JSON.parse(postFields);
    }
    doMessage(iObj) {
        if (iObj === null || iObj === void 0 ? void 0 : iObj.message) {
            let cb = document.querySelector('pic-choicebox[choicebox-x]');
            if (cb) {
                cb.data = {
                    choices: null,
                    choiceTitle: iObj.message,
                };
                cb.openBox();
            }
        }
    }
    handleEachGetAns() {
        let getAns = this.querySelector('.pic-modalcontainer');
        if (getAns) {
            getAns.style.setProperty('display', 'flex');
            getAns.style.setProperty('flex-direction', 'column');
            let getAnsChild = getAns.lastElementChild;
            if (getAnsChild) {
                let jSettings;
                try {
                    jSettings = objectDecoder(getAnsChild === null || getAnsChild === void 0 ? void 0 : getAnsChild.value);
                    if (jSettings.allowResize === true)
                        this.allowResize = true;
                    if (jSettings.disableNav === true)
                        this.disableNav = true;
                    if (jSettings.keepSize === true)
                        this.keepSize = true;
                    if (jSettings.centerOnParent === true)
                        this.centerOnParent = true;
                }
                catch (_a) {
                }
            }
        }
        this.requestUpdate();
    }
    render() {
        this.handleEachGetAns();
        return html `
        ${this.renderCSS(true)}
        <pic-modal 
            .isNew=${true}
            .isHidden=${this.isHidden}
            .parent=${this}
            .allowResize=${this.allowResize}
            .disableNav=${this.disableNav}
            .keepSize=${this.keepSize}
            .title_=${this.title_}
            .centerOnParent=${this.centerOnParent}
        >
            <div slot="slot-modal-hdr">
                <slot name="slot-getans-hdr">
                </slot>    
            </div>
            <div slot="slot-modal-body" class="bodycontainer getAnsBody">
                <slot name="slot-getans-body"></slot>  
            </div>
            <div slot="slot-modal-footer" class="getAnsFooter">
                <slot name="slot-getans-footer"></slot>    
            </div>
        </pic-modal>
        `;
    }
};
__decorate([
    property({ converter: stringDecoder, attribute: 'title' })
], PICGetAns.prototype, "title_", void 0);
__decorate([
    property({ converter: stringDecoder })
], PICGetAns.prototype, "format", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'allowresize' })
], PICGetAns.prototype, "allowResize", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'disablenav' })
], PICGetAns.prototype, "disableNav", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'keepsize' })
], PICGetAns.prototype, "keepSize", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'centerOnParent' })
], PICGetAns.prototype, "centerOnParent", void 0);
__decorate([
    query('pic-modal')
], PICGetAns.prototype, "modal", void 0);
PICGetAns = __decorate([
    customElement('pic-getans')
], PICGetAns);
export { PICGetAns };
//# sourceMappingURL=PICGetAns.js.map